import { LinkButton, Text } from '@etg/wings';
import { useState } from 'react';
import { airportRow, listWrapper, title } from '../../common/availability-components/styles';
import { useProductCardContext } from '../../common/context/ProductCardContext';
import AvailabilityStatus from '../../common/availability-components/AvailabilityStatus';
import { LoungeDrawer } from './LoungeDrawer';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const LoungeAirportList = props => {
  var _productData$extraPro, _productData$extraPro2;
  const productData = useProductCardContext();
  const [isOpen, setIsOpen] = useState(false);
  const [lounge, setLounge] = useState();
  const availabilityText = (_productData$extraPro = productData.extraProps) === null || _productData$extraPro === void 0 || (_productData$extraPro = _productData$extraPro.availabilityTranslation) === null || _productData$extraPro === void 0 ? void 0 : _productData$extraPro.availabilityCard;
  const drawerText = (_productData$extraPro2 = productData.extraProps) === null || _productData$extraPro2 === void 0 || (_productData$extraPro2 = _productData$extraPro2.availabilityTranslation) === null || _productData$extraPro2 === void 0 ? void 0 : _productData$extraPro2.drawer;
  const {
    availabilityList,
    testId,
    listTitle,
    isSelected,
    hideTitle
  } = props;
  const openDrawer = airport => {
    if (airport.loungeInfo) {
      setLounge(airport.loungeInfo);
    }
    setIsOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoungeDrawer, {
      drawerText: drawerText,
      isOpen: isOpen,
      loungeInfo: lounge,
      setOpen: setIsOpen
    }), (availabilityList === null || availabilityList === void 0 ? void 0 : availabilityList.length) > 0 && /*#__PURE__*/_jsxs("div", {
      "data-testid": testId,
      children: [!hideTitle && listTitle && /*#__PURE__*/_jsx("span", {
        className: title,
        children: listTitle
      }), /*#__PURE__*/_jsx("div", {
        className: listWrapper,
        children: availabilityList.map((airport, index) => {
          var _airport$loungeInfo;
          return /*#__PURE__*/_jsxs("div", {
            className: airportRow(airport.available),
            children: [/*#__PURE__*/_jsx("span", {
              className: "airportName",
              children: airport.departureAirport
            }), /*#__PURE__*/_jsx(AvailabilityStatus, {
              isAirportAvailable: airport.available,
              isCardSelected: isSelected,
              text: availabilityText
            }), airport.available && airport.loungeInfo && /*#__PURE__*/_jsxs("div", {
              className: "loungeName",
              children: [/*#__PURE__*/_jsx(Text, {
                children: (_airport$loungeInfo = airport.loungeInfo) === null || _airport$loungeInfo === void 0 ? void 0 : _airport$loungeInfo.loungeName
              }), /*#__PURE__*/_jsx(LinkButton, {
                "aria-controls": "lounge-info-drawer",
                "aria-expanded": isOpen,
                "aria-haspopup": "dialog",
                "data-testid": "loungeDrawerLink",
                onClick: () => openDrawer(airport),
                children: availabilityText.seeAll
              })]
            })]
          }, index);
        })
      })]
    })]
  });
};
export default LoungeAirportList;
//# sourceMappingURL=LoungeAirportList.js.map